export const SEARCH_TYPE = "search_type";
export const FIRST_NAME = "first_name";
export const LAST_NAME = "last_name";
export const SEARCH_CRITERIA = "search_criteria";

export const searchType = [
  { label: "User ID", value: "userName" },
  { label: "Alternate Login ID", value: "loginId" },
  { label: "Name", value: "name" },
  { label: "Mobile No.", value: "mobileNo" },
  { label: "Email ID", value: "email" },
];
